import { useCallback, useEffect } from 'react'
import { Spinner } from '@material-tailwind/react'
import { useTranslation } from 'react-i18next'
import ResponsiveDialog from '../components/ResponsiveDialog'
import { useUserAgamiListByExperience } from '../hooks/useUserAgamiListByExperience'
import Center from '../components/Center'
import AddAgamiToPatternTable from './AddAgamiToPatternTable'

interface AddAgamiToPatternProps {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  refetchAgamiList: () => Promise<void>
  currentPatternId: string
  currentExperienceId: string
}

const AddAgamiToPattern: React.FC<AddAgamiToPatternProps> = ({
  isOpen,
  setIsOpen,
  refetchAgamiList,
  currentPatternId,
  currentExperienceId,
}) => {
  const { t } = useTranslation()
  const {
    agamiList: agamiExpList,
    isLoading: agamiExpListLoading,
    refetch: refetchAgamiExpList,
  } = useUserAgamiListByExperience({
    experienceId: currentExperienceId,
  })

  const refetchAfterChange = useCallback(async () => {
    await refetchAgamiList()
    await refetchAgamiExpList()
  }, [refetchAgamiList, refetchAgamiExpList])

  useEffect(() => {
    if (!isOpen) {
      return
    }

    refetchAfterChange()
  }, [isOpen])

  return (
    <ResponsiveDialog isOpen={isOpen} setIsOpen={setIsOpen} title={t('pattern.addAgamiTitle')}>
      <div data-testid="add-agami-to-pattern-dialog">
        {agamiExpListLoading ? (
          <Center>
            <Spinner className="h-6 w-6 my-4" />
          </Center>
        ) : (
          <>
            {(!agamiExpList || agamiExpList.length === 0) && <span>{t('pattern.noAgamiInExperience')}</span>}

            {agamiExpList && agamiExpList.length > 0 && (
              <AddAgamiToPatternTable
                currentExpId={currentExperienceId}
                currentPatternId={currentPatternId}
                refetchAfterChange={refetchAfterChange}
                agamiList={agamiExpList}
              />
            )}
          </>
        )}
      </div>
    </ResponsiveDialog>
  )
}

export default AddAgamiToPattern
